import { useContext } from 'react'
import { useIntl } from 'react-intl'

import MessageBanner from 'LuxKit/Banners/MessageBanner'
import ContactContext from 'contexts/contactContext'
import { getChatTripPlannerNewChatPath } from 'tripPlanner/config'

interface Props {
  searchQuery?: string
}

function HotelSearchTripPlannerBanner({ searchQuery }: Props) {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const localContact = currentContact.local

  const heading = intl.formatMessage({
    id: '8tmAz0iZ6u13uIGeSG3A',
    defaultMessage: 'Continue planning your trip in Trip Planner',
    description: 'Heading on the hotel search banner that suggests continuing the search in Trip Planner',
  })
  const description = intl.formatMessage({
    id: 'zokWn-u6tMsOFecV-Axc',
    defaultMessage: 'Need help finding the perfect offer? Try our AI Trip Planner to discover personalised offers that match your search criteria.',
    description: 'Supporting copy on the hotel search banner that invites the user to try the AI trip planner with their current search',
  })
  const speakToExpertLabel = intl.formatMessage({
    id: '0aMeqk4gADA9ckji07PP',
    defaultMessage: 'Speak to a travel expert',
    description: 'Secondary action on the hotel search Trip Planner banner that calls a travel expert',
  })
  const tryTripPlannerLabel = intl.formatMessage({
    id: 'ROZwfxkHv5AwQNl-Gx4T',
    defaultMessage: 'Try AI trip planner',
    description: 'Primary action on the hotel search banner that opens a new tab with Trip Planner running the current search query',
  })
  const tripPlannerHref = getChatTripPlannerNewChatPath(searchQuery)

  return (
    <MessageBanner
      kind="promotional"
      heading={heading}
      secondaryActionButtonProps={{
        children: speakToExpertLabel,
        href: `tel:${localContact.number}`,
        rel: 'nofollow',
        size: 'small',
      }}
      primaryActionButtonProps={{
        children: tryTripPlannerLabel,
        to: tripPlannerHref,
        target: '_blank',
        size: 'small',
      }}
    >
      {description}
    </MessageBanner>
  )
}

export default HotelSearchTripPlannerBanner
